import { render, staticRenderFns } from "./VacationContentComponent.vue?vue&type=template&id=ce9a3964&scoped=true&"
import script from "./VacationContentComponent.vue?vue&type=script&lang=js&"
export * from "./VacationContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./VacationContentComponent.vue?vue&type=style&index=0&id=ce9a3964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9a3964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce9a3964')) {
      api.createRecord('ce9a3964', component.options)
    } else {
      api.reload('ce9a3964', component.options)
    }
    module.hot.accept("./VacationContentComponent.vue?vue&type=template&id=ce9a3964&scoped=true&", function () {
      api.rerender('ce9a3964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/components/VacationContentComponent.vue"
export default component.exports